export enum Tab {
  ReadingLogs = 'ReadingLogs',
  PatientSummary = 'PatientSummary',
}

export enum DateRangeType {
  Week = 'Week',
  Month = 'Month',
}
